<template>
  <v-btn
    icon
    class="mr-4"
    exact
    exact-active-class="badge-exact-disabled"
    :to="{ name: redirect }"
  >
    <v-badge
      :content="counter"
      :value="counter"
      color="primary"
      overlap
    >
      <v-img
        v-if="counter"
        :src="`/icons/icon_${icon}_on.svg`"
      />

      <v-img
        v-else
        :src="`/icons/icon_${icon}_off.svg`"
      />
    </v-badge>
  </v-btn>
</template>

<script>
export default {
  props: {
    counter: {
      type: Number,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    redirect: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.badge-exact-disabled {
  cursor: default;
  color: transparent !important;
}
</style>
